import React, { useRef } from 'react';

//components
import FormElementMenuButton from './FormElementMenuButton';

//interfaces
import { FormElementType } from '../interfaces/IFormElement';
import { useClickAwayClose } from '../../../hooks/useClickAwayClose';


const FormElementSelectMenu = (
    {
        onShortTextClick,
        onLongTextClick,
        onDropdownClick,
        onUserSelectClick,
        onCheckboxClick,
        onImageSelectClick,
        onVideoSelectClick,
        onFileSelectClick,
        onChoiceButtonClick,
        isOpen,
        handleClose,
        containerRef
    }:any) => {    
        useClickAwayClose(isOpen, containerRef, handleClose)
        
        return (
            <div className='form-element-select-menu' >  
                <FormElementMenuButton 
                    elementType= {FormElementType.SHORT_TEXT}
                    ariaLabel={'Add a short text element to form'} 
                    onButtonClick={onShortTextClick}
                />
                <FormElementMenuButton 
                    elementType= {FormElementType.LONG_TEXT}
                    ariaLabel={'Add a long text element to form'} 
                    onButtonClick={onLongTextClick}
                />
                <FormElementMenuButton 
                    elementType= {FormElementType.DROPDOWN}
                    ariaLabel={'Add a dropdown element to form'} 
                    onButtonClick={onDropdownClick}
                />

                <FormElementMenuButton 
                    elementType= {FormElementType.CHOICE_BUTTON}
                    ariaLabel={'Add a choice button element to form'} 
                    onButtonClick={onChoiceButtonClick}
                />

                <FormElementMenuButton 
                    elementType= {FormElementType.USER_SELECT}
                    ariaLabel={'Add a user select element to form'} 
                    onButtonClick={onUserSelectClick}
                />                
            
                <FormElementMenuButton 
                    elementType= {FormElementType.CHECKBOX}
                    ariaLabel={'Add a checkbox element to form'}
                    onButtonClick={onCheckboxClick}
                />
                <FormElementMenuButton 
                    elementType= {FormElementType.IMAGE_SELECT}
                    ariaLabel={'Add an image select element to form'}
                    onButtonClick={onImageSelectClick}
                />
                <FormElementMenuButton 
                    elementType= {FormElementType.VIDEO_SELECT}
                    ariaLabel={'Add a video select element to form'} 
                    onButtonClick={onVideoSelectClick}
                />
                <FormElementMenuButton 
                    elementType= {FormElementType.FILE_SELECT}
                    ariaLabel={'Add a file select element to form'}
                    onButtonClick={onFileSelectClick}
                />                
            </div>
    );
};

export default FormElementSelectMenu